import {
    Button,
    Col,
    Form,
    FormItem,
    Input,
    OnOffSwitch,
    Popup,
    PopupContent,
    PopupFooter,
    PopupTitle,
    Row,
    Toast
} from "@tv2no/ui-react";
import React, { useState } from "react";
import { columnLabels, editableColumns, sortColumns } from "../helpers";

export const EditGeoEntry = ({ unit, onClose, onReload, ...props }) => {
    const [entry, setEntry] = useState(props.entry);
    const [busySaving, setBusySaving] = useState(false);

    const onPropChange = (field, value) => {
        setEntry({
            _changed: true,
            ...entry,
            [field]: value
        });
    };

    const handleSave = () => {
        const updatedFields = Object.keys(entry)
            .filter((f) => editableColumns.includes(f))
            .reduce((agg, key) => {
                agg[key] = entry[key];
                return agg;
            }, {});

        setBusySaving(true);
        unit.updateEntry(entry[unit.identField], updatedFields).then(() => {
            Toast.success("Oppføringen ble lagret");
            setBusySaving(false);
            onReload();
            onClose();
        });
    };

    return (
        <Popup onClose={onClose}>
            <PopupTitle description={unit.label}>Rediger oppføring</PopupTitle>
            <PopupContent>
                <Form>
                    <Row>
                        {Object.keys(entry)
                            .filter((f) => editableColumns.includes(f))
                            .sort(sortColumns)
                            .map((field) => (
                                <Col key={field} span={24}>
                                    <FormItem label={columnLabels[field]}>
                                        {typeof entry[field] === "boolean" ? (
                                            <OnOffSwitch
                                                value={entry[field]}
                                                onChange={(val) => onPropChange(field, val)}
                                            />
                                        ) : (
                                            <Input
                                                value={entry[field]}
                                                onChange={(val) => onPropChange(field, val)}
                                            />
                                        )}
                                    </FormItem>
                                </Col>
                            ))}
                    </Row>
                </Form>
            </PopupContent>
            <PopupFooter>
                <Button
                    color="primary"
                    disabled={!entry?._changed}
                    onClick={handleSave}
                    busy={busySaving}
                >
                    Lagre endringer
                </Button>
            </PopupFooter>
        </Popup>
    );
};
